import {Divider, Stack, Typography} from "@mui/material";
import ScreenWrapper from "crqlar-react-common/dist/components/ScreenWrapper";
import {useTranslation} from "react-i18next";
import {useMarketplaceApps} from "crqlar-react-common/dist/utils/hooks/app/useMarketplaceApps";
import {useOrganizationApps} from "crqlar-react-common/dist/utils/hooks/app/useOrganizationApps";
import AppListItem from "./AppListItem";
import {useTrackScreenVisit} from "crqlar-react-common/dist/utils/analytics.util";

const AllApps = () => {

    useTrackScreenVisit('marketplace')

    const {t} = useTranslation()
    const allApps = useMarketplaceApps()
    const myApps = useOrganizationApps()

    const installedApps = allApps.filter(app => myApps.some(myApp => myApp.appId === app.id))
    const notInstalledApps = allApps.filter(app => !myApps.some(myApp => myApp.appId === app.id))

    return (
        <ScreenWrapper>
            <Stack
                gap={4}
                width={'100%'}
                maxWidth={'1500px'}
            >
                <Typography variant={'h4'}>
                    {t('My Apps and Integrations')}
                </Typography>

                <Stack gap={4} direction={'row'} flexWrap={'wrap'}>
                    {installedApps.map(app => (
                        <AppListItem
                            key={app.id}
                            isActive
                            isMultiInstance={app.sku === 'reservations'}
                            instances={1}
                            app={app}
                            onInstall={() => {
                            }}
                            onUninstall={() => {
                            }}
                            onOpen={() => {
                            }}
                        />
                    ))}
                </Stack>

                <Divider/>

                <Typography variant={'h4'}>
                    {t('Crqlar Marketplace')}
                </Typography>

                <Stack gap={4} direction={'row'} flexWrap={'wrap'}>
                    {notInstalledApps.map(app => (
                        <AppListItem
                            key={app.id}
                            app={app}
                            onInstall={() => {
                            }}
                            onUninstall={() => {
                            }}
                            onOpen={() => {
                            }}
                        />
                    ))}
                </Stack>
            </Stack>
        </ScreenWrapper>
    )
}

export default AllApps;
